export default {
    /* GET_SHIPPING_ORDERS
    ---------------------------------------------------------------
    */
    GET_SHIPPING_ORDERS_REQUEST: state => {
        state.shippingOrdersLoading = true
    },
    GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_REQUEST: state => {
        state.shippingOrdersForShippingLabelsLoading = true
    },
    GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_SUCCESS: (state, data) => {
        state.shippingOrdersForShippingLabels = data.results
        state.shippingOrdersForShippingLabelsLoading = false
    },
    GET_SHIPPING_ORDERS_FOR_SHIPPING_LABELS_FAILURE: state => {
        state.shippingOrdersForShippingLabelsLoading = false
    },

    GET_SHIPPING_ORDERS_SUCCESS: (state, data) => {
        state.shippingOrders = data.results
        state.shippingOrdersLoading = false
    },
    GET_SHIPPING_ORDERS_FAILURE: state => {
        state.shippingOrdersLoading = false
    },
    GET_SHIPPING_ORDER_STATUSES: (state, data) => {
        state.shippingOrderStatuses = data.results
    },
    SET_SHIPPING_ORDERS_FILTERS: (state, filters) => {
        state.shippingOrdersFilters = filters
    },
    CLEAR_SHIPPING_ORDERS_FILTERS: state => {
        state.shippingOrdersFilters = state.setInitialShipmentsOrdersFilters()
    }
}
